import { render, staticRenderFns } from "./AddExam.vue?vue&type=template&id=3d75bd3c&"
import script from "./AddExam.vue?vue&type=script&lang=js&"
export * from "./AddExam.vue?vue&type=script&lang=js&"
import style0 from "./AddExam.vue?vue&type=style&index=0&id=3d75bd3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports